module.exports = __webpack_public_path__ + "img/fleche_chevron.a121d1bd.svg";